interface SkeletonProps {
  className?: string;
  /** Width (Tailwind class like "w-full" or "w-32") */
  width?: string;
  /** Height (Tailwind class like "h-4" or "h-8") */
  height?: string;
  /** Shape variant */
  variant?: 'text' | 'circle' | 'rect' | 'card';
}

const variantClasses = {
  text: 'rounded',
  circle: 'rounded-full',
  rect: 'rounded-lg',
  card: 'rounded-xl',
} as const;

/**
 * Skeleton - Animated placeholder for loading states.
 *
 * Renders a pulsing shape that matches the layout of the content it replaces,
 * improving perceived performance over a generic spinner.
 */
export function Skeleton({
  className = '',
  width = 'w-full',
  height = 'h-4',
  variant = 'text',
}: SkeletonProps) {
  return (
    <div
      className={`animate-pulse bg-[var(--color-border)] ${variantClasses[variant]} ${width} ${height} ${className}`}
      aria-hidden="true"
    />
  );
}

export default Skeleton;
